import { ReactElement, Dispatch, SetStateAction } from 'react';
import { Card, Container, styled, useMediaQuery } from '@mui/material';
import { canOperate, IUser, PDFModal, TabPanel, useRoleOpContext } from '../common';
import { labels, panels, Nav } from '.';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';

export const Tabs = ({
  user,
  currentTab,
  setCurrentTab,
  rpsPage, 
  operationsPage,
}: {
  user: IUser;
  currentTab: number;
  setCurrentTab: Dispatch<SetStateAction<number>>;
  rpsPage?: boolean;
  operationsPage?: boolean;
}) => {
  const { operations } = useRoleOpContext();

  const currentLabel = lcompose(lpropOr('', `[${currentTab}].label`))(
    labels(operations, operationsPage)
  );

  const child = (
    <Wrapper>
      <section className="flex-align-items-baseline-justify-content-space-between margin-top-1 margin-left-1">
        <PDFModal
          fileUrl={'Helpdesk Support Tab.pdf'}
          fileLabel={rpsPage ? 'rps instructions' : 'help desk instructions'}
          fileDownload="help_desk.pdf"
        />
        {rpsPage ? <a
          href={`${import.meta.env.VITE_DC_ENROLLMENT}`}
          target="_blank"
          rel="noreferrer">
          Request Access to RPS Reports
        </a> : null}
        <a
          href={`${import.meta.env.VITE_DI_REPORTS}`}
          target="_blank"
          rel="noreferrer">
          CSOS1 User Search
        </a>
      </section>
      <Nav
        currentTab={currentTab}
        operations={operations}
        setCurrentTab={setCurrentTab}
        operationsPage={operationsPage}
      />

      {currentLabel !== '' && (
        <TabPanel value={currentTab} label={currentLabel}>
          {lfind<{
            value: number;
            panel: () => ReactElement;
          }>({ value: currentTab })(panels({ user, rpsPage, operationsPage }))!.panel()}
        </TabPanel>
      )}
    </Wrapper>
  );

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return matchesGridBreakpoint ? (
    <Container maxWidth={false} data-testid="team-testid">
      <Card>{child}</Card>
    </Container>
  ) : (
    child
  );
};

const Wrapper = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem !important',
  },
}));
